module.exports = __webpack_public_path__ + "img/09n.06e5312a.svg";